// hooks/useFetchStatistics.ts
import { useState, useEffect } from "react";
import axios from "axios";
import { Statistics } from "../../const/statistic.const";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

const userFetchProfile = (token: string) => {


  const { getAccessTokenSilently, isAuthenticated } = useAuth0()


  const [profile, setStatistics] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const tk = await getAccessTokenSilently()
        const response = await axios.get<{ data: any }>(
          `${apiUrl}/api/v1/profile`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );
        setStatistics(response);
      } catch (err) {
        setError("Error fetching statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, [token]);

  return { profile, loading, error };
};

export default userFetchProfile;
